import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import eventTypes from '../../../../enums/Event.enums';
import { TStringField } from '../../../../types/types';
import { TNavigationBarTabsDesktopProps } from '../types/navigationBar.types';

const NavigationBarTabsDesktop: FC<TNavigationBarTabsDesktopProps> = (props) => {
  const { tabs, scrollToPlaceholder, clickPageNavEvent, activeTab, isEditorial } = props;

  return (
    <ul className={'navigation-bar__tabs'}>
      {tabs?.map((tab, index) => (
        <li
          role={'listitem'}
          className={`navigation-bar__tab ${activeTab === index ? 'navigation-bar__tab--active' : ''} ${
            !tab?.isVisible ? 'navigation-bar__tab--hidden' : ''
          }`}
          key={index}
          onClick={() => {
            scrollToPlaceholder(index);
            clickPageNavEvent(eventTypes.navEvent, isEditorial ? (tab?.label as TStringField)?.value : (tab?.label as string), index + 1);
          }}
        >
          <Text
            tag="div"
            field={isEditorial ? (tab?.label as TStringField) : ({ value: tab?.label } as TStringField)}
            editable={isEditorial}
          />
        </li>
      ))}
    </ul>
  );
};

export default NavigationBarTabsDesktop;
